import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.754 6.234a2.234 2.234 0 1 1 4.467 0 2.234 2.234 0 0 1-4.467 0M11.988 2a4.234 4.234 0 1 0 0 8.467 4.234 4.234 0 0 0 0-8.467m-.37 9.995Q11.826 12 12 12q.176 0 .382-.005c1.082-.02 2.761-.053 4.125 1.002C18.095 14.224 19 16.645 19 21a1 1 0 1 1-2 0c0-4.212-.9-5.79-1.716-6.421-.772-.597-1.698-.59-2.85-.581a55 55 0 0 1-.868 0c-1.152-.009-2.078-.016-2.85.58C7.902 15.21 7 16.789 7 21a1 1 0 1 1-2 0c0-4.355.906-6.776 2.493-8.004 1.364-1.054 3.044-1.022 4.125-1.001M9 21a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: t };
export {
  d as default,
  t as render
};
//# sourceMappingURL=ic_profile-V223iRtn.js.map
